<template>
  <section>
    <div class="jifen">
      <div class="user-main">
        <div class="user-cont layui-card">
          <div class="layui-card-header layui-card-header-auto">
            <div class="utab clearfix">
              <ul class="clearlist clearfix fl">
                <li class="active">
                  <a href="javascript:;">授信明细</a>
                </li>
              </ul>
            </div>
            <div class="jifentongji flex">
              <div class="wyjifen">
                <p>我的授信</p>
                <span class="iconfont icon-gold color-primary"></span>
                <p class="num">{{shouxinLog.yue}}</p>
              </div>
              <div class="jifenmingxi">
                <div class="title">最近三个月授信统计</div>
                <div class="jifentype flex ju-be">
                  <li>
                    <span class="type">总入账</span>
                    <div class>
                      <span>+</span>
                      <span class="num">{{shouxinLog.income}}</span>
                    </div>
                  </li>
                  <li>
                    <span class="type">总支出</span>
                    <div class>
                      <!-- <span>+</span> -->
                      <span class="num">{{shouxinLog.balance}}</span>
                    </div>
                  </li>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <el-table :data="shouxinLog.list.data" style="width: 95%;margin:auto">
          <el-table-column prop="addtime" label="最近3个月"></el-table-column>
          <el-table-column prop="amount" label="金额" width="100"></el-table-column>
          <el-table-column prop="" label="所属部门">
            <template slot-scope="scope">
              <span v-if="scope.row.departname">{{scope.row.departname}}</span>
              <span v-else>当前账号</span>
            </template>
          </el-table-column>
            <el-table-column prop="classfy" label="类型"></el-table-column>
          <el-table-column prop="remark1" label="详细说明"></el-table-column>
        </el-table>
        <el-pagination
          class="fenye"
          background
          layout="prev, pager, next"
          :page-size="shouxinLog.list.per_page"
          @current-change="currentPage"
          :total="shouxinLog.list.total"
        ></el-pagination>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Coupons",
  data() {
    return {
      shouxinLog: { list: {} },
      goodsList: {},
      page: 1,
      departmentList:[],
      type: "account3",
      guid: sessionStorage.guid
    };
  },
  props: {},
  methods: {
    // 改变当前页
    currentPage(e) {
      this.page = e;
      this.getshouxinList();
    },

    async getshouxinList() {
      let res = await await this.$fetch("member/balance", {
        body: {
          page: this.page,
          type: this.type
        }
      });
      let arr = res.list.data;
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].type == 1) {
          arr[i].amount = "+" + arr[i].amount;
        } else {
          arr[i].amount = "-" + arr[i].amount;
        }
        for (let key in res.typelist) {
          if (arr[i].typeid == key) {
            arr[i]["classfy"] = res.typelist[key];
          }
        }
        // 部门名字
        for(let j=0;j<this.departmentList.length;j++){
          if(arr[i].departid==this.departmentList[j].id){
            arr[i]['departname']=this.departmentList[j].name
          }
        }
      }
      res.list.data = arr;
      res["yue"] = (
        parseFloat(res.authmoney) + parseFloat(res.balance)
      ).toFixed(2);
      this.shouxinLog = res;
      console.log("shouxinLogshouxinLog", res);
    },
    // 获取部门列表
    async getdepartmentList() {
      let departmentList = await this.$fetch("shop/department", {
        body: {
          act: "list"
        }
      });
      console.log("departmentListdepartmentList", departmentList);
      this.departmentList = departmentList;
    }
  },
async  mounted() {
    await this.getdepartmentList();
    this.getshouxinList();
  }
};
</script>
<style lang='scss' scoped>
.jifentongji {
  font-size: 20px;
  font-size: 20px;
  align-items: flex-start;
  justify-content: space-around;
  .wyjifen {
    width: 100px;
    .icon-gold {
      font-size: 50px;
    }
    .num {
      font-size: 30px;
      margin: 0;
      font-weight: normal;
    }
  }
  .jifenmingxi {
    width: 450px;
    margin-top: 15px;
    font-size: 16px;
    font-weight: bold;
    .jifentype {
      width: 100%;
      margin-top: 30px;
      .type {
        font-size: 12px;
      }
      .num {
        font-size: 30px;
        font-weight: normal;
      }
    }
  }
}
.jifenSC {
  padding: 20px;
  box-sizing: border-box;
  .active {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    display: inline-block;
    color: rgba(243, 153, 10, 1);
    border-bottom: 2px solid #f3990a;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/qy_shouxin.vue